import { useEffect, useState } from 'react';
import { studioApi, errorKey } from '../../../data/studioApi';

// `/studio/mobile?project=<id>` is a permanent locator, never a credential: the
// creator signs in with the same account and the server checks ownership on
// every read. The teleprompter always opens the latest saved revision.
// Handoff (`#handoff=`) and `/studio/mobile-sessions/:id` links came from the
// local preview; contract 1.1.0 removed them, so they only explain themselves.
export default function useMobileWorkspace(s) {
  const projectId = new URLSearchParams(s.location.search).get('project');
  const legacy = s.location.pathname.startsWith('/studio/mobile-sessions/') || new URLSearchParams(s.location.hash.slice(1)).has('handoff');
  const [state, setState] = useState({ status: 'idle', revision: null, error: null });
  const signed = s.auth.signed;
  useEffect(() => {
    if (!projectId || !signed) return undefined;
    let alive = true;
    setState({ status: 'loading', revision: null, error: null });
    (async () => {
      try {
        const project = await studioApi.project(projectId);
        if (project.status === 'archived' || !project.latest_revision_id) throw Object.assign(new Error('No saved script'), { code: 'not_found' });
        const revision = await studioApi.revision(project.latest_revision_id);
        if (alive) setState({ status: 'ready', revision, error: null });
      } catch (failure) {
        if (alive) setState({ status: 'error', revision: null, error: errorKey(failure) });
      }
    })();
    return () => { alive = false; };
  }, [projectId, signed]);
  return { projectId, legacy, ...state, login: () => s.auth.goToAuth() };
}
